module.exports = __webpack_public_path__ + "static/media/PRAGATI.32194bc0.svg";